/**
 * Date utility functions
 */

/**
 * Check if a date is older than a specified number of months
 * @param date - Date string, Date object, or null/undefined
 * @param months - Number of months to check against
 * @returns true if date is older than specified months, false otherwise
 */
export const isDateOlderThanMonths = (
  date: string | Date | null | undefined,
  months: number
): boolean => {
  if (!date) return false;

  // Convert string to Date object if needed
  const dateObj = typeof date === "string" ? new Date(date) : date;

  // Check if date is valid
  if (isNaN(dateObj.getTime())) return false;

  // Calculate date N months ago
  const monthsAgo = new Date();
  monthsAgo.setMonth(monthsAgo.getMonth() - months);

  return dateObj < monthsAgo;
};

/**
 * Format a date for display in tooltips
 * @param date - Date string or Date object
 * @returns Formatted date string (e.g., "Jan 15, 2024")
 */
export const formatDateForDisplay = (
  date: string | Date | null | undefined
): string => {
  if (!date) return "Unknown";

  const dateObj = typeof date === "string" ? new Date(date) : date;

  if (isNaN(dateObj.getTime())) return "Unknown";

  return dateObj.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};
